<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('WORKTYPE')">
        <inputvalidation :formerror="formError" name="workType">
          <b-form-input type="text" v-model="formData.workType"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
</div>
</template>

<script>
export default
{
  name: 'WorkTypeForm',
  props: ['formData', 'formError']
}
</script>
